import React from 'react';
import { Clock, Calendar, Sparkles } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export function Services() {
  const { t } = useLanguage();

  return (
    <section id="services" className="services">
      <div className="services__container">
        {/* Main Title */}
        <div className="services__header">
          <h2 className="services__title">{t('services.title')}</h2>
          <p className="services__description">
            {t('services.description')}
          </p>
        </div>

        <div className="services__grid">
          {/* Weekly Services Card */}
          <div className="services__card">
            <div className="services__card-header">
              <Clock size={28} />
              <h3 className="services__card-title">{t('services.weekly.title')}</h3>
            </div>
            <div className="services__list">
              <div className="services__item">
                <span className="services__item-name">{t('services.weekly.tuesday')}</span>
              </div>
              <div className="services__item">
                <span className="services__item-name">{t('services.weekly.friday')}</span>
              </div>
            </div>
          </div>

          {/* Monthly Special Events Card */}
          <div className="services__card">
            <div className="services__card-header">
              <Calendar size={28} />
              <h3 className="services__card-title">{t('services.monthly.title')}</h3>
            </div>
            <div className="services__list">
              <div className="services__item">
                <span className="services__item-name">{t('services.monthly.amavasai')}</span>
              </div>
              <div className="services__item">
                <span className="services__item-name">{t('services.monthly.thai')}</span>
              </div>
              <div className="services__item">
                <span className="services__item-name">{t('services.monthly.aadi')}</span>
              </div>
            </div>
          </div>

          {/* Annual Festivals Card */}
          <div className="services__card">
            <div className="services__card-header">
              <Sparkles size={28} />
              <h3 className="services__card-title">{t('services.annual.title')}</h3>
            </div>
            <div className="services__list">
              <div className="services__item">
                <span className="services__item-name">{t('services.annual.chithirai')}</span>
              </div>
              <div className="services__item">
                <span className="services__item-name">{t('services.annual.margazhi')}</span>
              </div>
              <div className="services__item">
                <span className="services__item-name">{t('services.annual.ashtami')}</span>
              </div>
            </div>
          </div>

          {/* Special Healing Services Card */}
          <div className="services__card services__card--special">
            <div className="services__card-header">
              <Sparkles size={28} />
              <h3 className="services__card-title">{t('services.healing.title')}</h3>
            </div>
            <div className="services__list">
              <p className="services__healing-text">{t('services.healing.desc')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}